
import { Component, Vue } from 'vue-property-decorator'

export default class UnderMaintenance extends Vue {
  public currentYear = new Date().getFullYear()
}
